<template>
  <section>
    <div class="gift-list">
      <div
        :class="gift.quantity > 0 ? 'gift' : 'gift out_of_stock'"
        v-bind:key="gift"
        v-for="gift in items"
      >
        <div class="gift-picture" @click.prevent="onClickImage(gift)">
          <img :src="GiftImage(gift.picture)" :alt="$t('attributes.picture')" />
        </div>
        <p class="gift-name">{{ gift.name }}</p>
        <div class="gift-content">
          <p class="gift-quantity">數量：{{ gift.quantity }}</p>
          <p class="gift-net-price">$ {{ gift.net_price }}</p>
        </div>
      </div>
    </div>
    <b-modal has-modal-card :active.sync="isImageModalActive">
      <p v-if="showGift" class="image">
        <img
          style="max-width: 450px; max-height: 800px; text-align: center;"
          :src="GiftImage(showGift.picture)"
          :alt="showGift.name"
        />
      </p>
    </b-modal>
  </section>
</template>
<style>
.gift-list {
  margin: 0 25px;
  display: block;
  position: relative;
}
.gift-list .gift {
  display: inline-block;
  width: 220px;
  margin: 15px;
}
.gift-list .gift.out_of_stock .gift-name,
.gift-list .gift.out_of_stock .gift-content .gift-quantity,
.gift-list .gift.out_of_stock .gift-content .gift-net-price {
  color: #c0c0c0 !important;
}
.gift-list .gift.out_of_stock .gift-picture {
  opacity: 0.2;
}
.gift-list .gift:hover {
  background-color: #ffffb9;
}
.gift-list .gift .gift-picture {
  height: 220px;
  text-align: center;
  cursor: pointer;
  overflow: hidden;
}
.gift-list .gift img {
  max-height: 220px;
}
.gift-list .gift .gift-name,
.gift-list .gift .gift-content {
  padding: 0 30px;
}
.gift-list .gift .gift-name {
  font-size: 1em;
  color: #000000;
  line-height: 48px;
}
.gift-list .gift .gift-content p {
  display: inline-block;
  margin-bottom: 5px;
}
.gift-list .gift .gift-content p:nth-child(1) {
  width: 100px;
}
.gift-list .gift .gift-content p:nth-child(2) {
  width: 60px;
}
.gift-list .gift .gift-content .gift-quantity {
  font-size: 20px;
  font-weight: 600;
  color: #ff0080;
  text-align: left;
}
.gift-list .gift .gift-content .gift-net-price {
  text-align: right;
  font-size: 15px;
}
</style>
<script>
import notifyService from '@/services/notifyService'
import { GIFTS_API } from '@/utils/apis'
export default {
  name: 'GiftMenu',
  data() {
    return {
      loadingItems: false,
      items: [],

      showGift: null,
      isImageModalActive: false
    }
  },
  mounted() {
    this.loadItems()
  },
  methods: {
    async loadItems() {
      try {
        const api = `${GIFTS_API}/list-apply`
        const params = {
          search: null
        }

        this.loadingItems = true
        const res = await this.axios.get(api, { params })
        this.items = res.data.data
      } catch (e) {
        notifyService.fetch_error('gift', e)
      } finally {
        this.loadingItems = false
      }
    },
    onClickImage(gift) {
      this.showGift = gift
      this.isImageModalActive = true
    }
  }
}
</script>
